import React                  from 'react';
import PartNumber             from 'pu-react/components/PartNumber';
import StencilFile            from 'pu-react/components/StencilFile';
import StencilThickness       from 'pu-react/components/StencilThickness';
import StencilMaterial        from 'pu-react/components/StencilMaterial';
import StencilSide            from 'pu-react/components/StencilSide';
import StencilWidth           from 'pu-react/components/StencilWidthSelect';
import StencilLength          from 'pu-react/components/StencilLengthSelect';
import StencilPanelize        from 'pu-react/components/StencilPanelize';
import PrintConfirmationRadio from 'pu-react/components/PrintConfirmationRadio';
import SpecialInstruction     from 'pu-react/components/SpecialInstruction';
import ProductQuoteNumber     from 'pu-react/components/ProductQuoteNumber';

import {
  stencilThickness as stencilThicknessOptions,
  material as materialOptions,
  lengthOptions,
  widthOptions,
} from '../data/SelectOptions';

export default props => (
  <div>
    <div className="row">
      <div className="col-12 col-md-6 col-lg-4 col-xl-3">
        <PartNumber {...props} className="ignore-on-quote" />
      </div>
      <div className="col-12 col-md-6 col-lg-4 col-xl-3">
        <StencilFile {...props} />
      </div>
      <div className="col-12 col-md-6 col-lg-4 col-xl-3">
        <StencilThickness
          {...props}
          options={stencilThicknessOptions}
          name="mylar_thickness"
          inputClassName="ignore-on-quote" />
      </div>
      <div className="col-12 col-md-6 col-lg-4 col-xl-3">
        <StencilMaterial
          {...props}
          options={materialOptions}
          name="mylar_material" />
      </div>
      <div className="col-12 col-md-6 col-lg-4 col-xl-3">
        <StencilLength
          {...props}
          options={lengthOptions}
          name="mylar_length" />
      </div>
      <div className="col-12 col-md-6 col-lg-4 col-xl-3">
        <StencilWidth
          {...props}
          options={widthOptions}
          name="mylar_width" />
      </div>
      <div className="col-12 col-md-6 col-lg-4 col-xl-3">
        <StencilSide {...props} inputClassName="ignore-on-quote" />
      </div>
      <div className="col-12 col-md-6 col-lg-4 col-xl-3">
        <StencilPanelize {...props} inputClassName="ignore-on-quote" />
      </div>
      <div className="col-12 col-md-6 col-lg-4 col-xl-3">
        <PrintConfirmationRadio {...props} inputClassName="ignore-on-quote" />
      </div>
      <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
        <SpecialInstruction {...props} />
      </div>
      <ProductQuoteNumber {...props} />
    </div>
  </div>
);
